
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1634495198314",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3933",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M780.56106667 999.0144H244.80426667c-121.6512 0-220.22826667-98.57706667-220.22826667-220.22826668V243.02933332c0-121.6512 98.57706667-220.22826667 220.22826667-220.22826664h535.7568c121.6512 0 220.22826667 98.57706667 220.22826666 220.22826664v535.7568c0 121.6512-98.57706667 220.22826667-220.22826666 220.22826668z",
        "fill": "#009CF5",
        "p-id": "3934"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M530.97813333 591.4624h-107.17866666l80.69120001-139.264 8.19199999-14.19946667 55.296-95.0272 10.6496-18.56853333 22.93760001-39.3216c10.10346667-17.2032 10.37653333-39.3216-1.09226668-55.56906668-9.8304-13.9264-23.89333333-19.52426668-37.81973333-19.52426665-16.384 0-32.3584 8.46506668-41.3696 23.7568l-8.19199999 14.47253333-8.46506668-14.47253333c-9.0112-15.29173333-25.12213333-23.7568-41.3696-23.7568-8.192 0-16.384 1.91146667-24.02986667 6.28053333-22.66453333 13.1072-30.44693333 42.46186667-17.2032 65.1264l35.6352 61.57653333-144.1792 248.76373335H219.81866667c-28.672 0.27306667-51.6096 25.66826668-47.10399999 55.56906664 3.54986668 23.48373332 25.53173333 39.86773333 49.28853332 39.86773335h36.18133333l110.31893334-0.27306667h220.22826666c4.096 0 8.192-1.77493333 10.64959999-5.05173333 12.56106667-16.7936 21.84533333-42.87146668-8.87466664-69.76853334-16.24746667-14.336-37.95626668-20.61653333-59.52853335-20.61653333z",
        "fill": "#FFFFFF",
        "p-id": "3935"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M803.49866667 591.18933333h-91.7504L589.0048 379.42613332c-2.18453333-3.6864-7.09973333-4.9152-10.51306668-2.4576-17.2032 12.42453332-27.30666667 29.76426667-32.49493332 48.87893336-8.73813332 32.22186667-1.50186667 66.7648 15.1552 95.70986665l26.35093333 45.73866667 13.9264 24.30293333 55.296 95.30026667 5.7344 9.55733332 53.11146667 91.75040001c9.0112 15.29173333 24.84906667 23.7568 41.09653332 23.75679999 8.192 0 16.65706667-2.18453333 24.30293336-6.55359999 22.66453333-13.1072 30.44693333-42.1888 17.2032-65.1264l-30.99306668-53.65760001h38.63893332c28.672 0 51.47306668-25.94133332 46.83093335-55.84213332-3.82293332-23.3472-25.53173333-39.59466667-49.152-39.59466667zM306.7904 699.32373333c-16.7936-6.82666667-32.63146667-6.00746668-45.32906668-2.4576-6.9632 1.91146667-12.6976 6.69013333-16.24746664 12.83413335l-17.74933335 30.31039999c-13.38026668 22.9376-5.46133333 52.0192 17.2032 65.1264 7.64586667 4.36906667 16.11093332 6.5536 24.30293334 6.55360001 16.384 0 32.08533332-8.46506668 40.82346666-23.75680001l20.20693335-34.816c4.9152-8.6016 5.87093333-18.97813333 2.18453332-28.12586667-4.096-10.24-11.74186667-20.0704-25.3952-25.66826667z",
        "fill": "#FFFFFF",
        "p-id": "3936"
      }
    }
  ]
})
    }
  